/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Business relation type
 * @export
 */
export const BusinessRelationType = {
    PrivateBanking: 'PRIVATE_BANKING',
    IntermediaryB2B: 'INTERMEDIARY_B2B'
} as const;
export type BusinessRelationType = typeof BusinessRelationType[keyof typeof BusinessRelationType];


export function instanceOfBusinessRelationType(value: any): boolean {
    for (const key in BusinessRelationType) {
        if (Object.prototype.hasOwnProperty.call(BusinessRelationType, key)) {
            if (BusinessRelationType[key as keyof typeof BusinessRelationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BusinessRelationTypeFromJSON(json: any): BusinessRelationType {
    return BusinessRelationTypeFromJSONTyped(json, false);
}

export function BusinessRelationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessRelationType {
    return json as BusinessRelationType;
}

export function BusinessRelationTypeToJSON(value?: BusinessRelationType | null): any {
    return value as any;
}

export function BusinessRelationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BusinessRelationType {
    return value as BusinessRelationType;
}

